import BlogPost from "../../../../content/posts/react-text-to-speech-component/BlogPost";
import * as React from 'react';
export default {
  BlogPost,
  React
};